import React, { useState } from "react";
import { Badge, Button, Modal, OutOfPolicyBadge } from "../../../../../../../../Components";
import { useUserConfig } from "../../../../../../../../Hooks/useUserConfig";
import { formatedPrice } from "../../../../../../../../Utils/utils";

function Fare({ selected, flight, fare, cheapestFare, highestFare, onSelect, approval, familyFare }) {
	const { checkUserPermission } = useUserConfig();
	const approvedAmount = approval?.amount;
	const { fareKey, price, inPolicy, violations, currency, includedServices, bundledServiceName } = fare;
	const active = selected && selected.selectedFare.fareKey === fareKey;
	const askApproval = !inPolicy && !checkUserPermission("TA") && (approvedAmount ? price > Number(approvedAmount) : true);

	const [ShowServices, setShowServices] = useState(false);

	if (price > 0)
		return (
			<>
				<div className="flex flex-col justify-between flex-1 gap-2 p-5 m-auto text-center flex-center">
					{askApproval ? <OutOfPolicyBadge violations={[...new Set([...violations, ...flight.violations])]} /> : <></>}
					{bundledServiceName && <p className="text-sm font-bold uppercase text-nowrap">{bundledServiceName}</p>}
					{includedServices?.length > 0 && (
						<div className="relative group inline-block">
							<Badge onClick={() => setShowServices(true)} className="text-xs cursor-pointer hover:bg-green-500 hover:text-white">
								Included Perks
							</Badge>
							<div className="absolute bottom-full mb-1 left-1/2 transform -translate-x-1/2 scale-0 group-hover:scale-100 transition-all bg-black text-white text-[10px] px-2 py-1 rounded-md whitespace-nowrap z-10">
								Click to see all Perks
							</div>
						</div>
					)}
					<p className="text-lg font-bold text-nowrap">
						{currency} {formatedPrice(price)}
					</p>
					{onSelect &&
						(active ? (
							<Button onClick={() => onSelect()} className="w-full mt-2 btn-sm">
								Remove
							</Button>
						) : (
							<Button onClick={() => onSelect(fare)} variant="outlined" className="w-full mt-2 btn-sm">
								Choose
							</Button>
						))}
				</div>
				<Modal open={ShowServices} onClose={() => setShowServices(false)}>
					<div className="p-4">
						<h3 className="mb-4">🚀 What's included in this fare</h3>
						<ul className="space-y-2">
							{includedServices?.map((service) => (
								<Badge key={service}>{service.replace(/[^\x20-\x7Eáéíóúñ]/g, "")}</Badge>
							))}
						</ul>
					</div>
				</Modal>
			</>
		);
	return null;
}

export default Fare;
